import { connect } from 'react-redux';
import { sendHotelFeedback, loadHotel } from '../modules/feedback';

import Feedback from '../components/Feedback';


const mapDispatchToProps = {
  sendHotelFeedback,
  loadHotel,
};

const mapStateToProps = state => ({
  isFetching: state.feedback.isFetching,
  needFetch: state.feedback.needFetch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);



// WEBPACK FOOTER //
// src/routes/feedback/containers/FeedbackContainer.js